module.exports = function init_forms() {



    // prevent multiple submissions for any advanced form
    // note: this event appears to only fire after successful validation; no need to re-enable the submit button
    // another note: gently disabling the button does not work - it needs to be completely destroyed to prevent multiple submissions
    document.querySelector('form.af-form')?.addEventListener('submit', (event) => {

        const submit_parent = event.currentTarget.querySelector('.af-submit');
        const submit_button = submit_parent.querySelector('.af-submit-button');
        
        if (submit_button && submit_parent) {
            
            // Create the replacement div
            const faux_button = document.createElement('div');
            faux_button.className = 'faux-button';
            faux_button.textContent = 'Processing...';
            
            // Replace the button
            submit_button.insertAdjacentElement('afterend', faux_button); // Insert right after the button to keep layout relationship to ajax spinner
            submit_button.remove();
        }
    });

    // for all ACF forms, add custom style/content to the basic uploader button
    (function($) {
        // add a custom label element after the file input
        $('.acf-field.form-upload .acf-basic-uploader input[type="file"]').each(function() {
            var $input = $(this);
            // only add the label if it doesn't already exist
            if (!$input.next('label').length) {
                // wrap in a container for better styling
                $input.wrap('<div class="custom-file-wrapper"></div>');
                
                // add the button label
                $input.after('<label for="' + $input.attr('id') + '">Choose File</label>');
                
                // add a separate filename display element
                $input.next('label').after('<div class="file-info">No file selected</div>');
                
                // update filename display when file is selected
                $input.on('change', function() {
                    var filename = $(this).val().split('\\').pop();
                    if (filename) {
                        $(this).parent().find('.file-info').text(filename);
                    } else {
                        $(this).parent().find('.file-info').text('No file selected');
                    }
                });
            }
        });
    })(jQuery);

    // for all ACF forms, listen for tooltip triggers
    (function($) {

        $('.acf-field.tooltip-trigger').on('click', function(e) {
           
            e.preventDefault();
            e.stopPropagation();

            const $parent = $(this).closest('.acf-field.tooltip-trigger');
            const classes = $parent.attr('class').split(/\s+/);
            const trigger_class = classes.find(cls => cls.startsWith('tooltip-trigger-') && cls !== 'tooltip-trigger');
            
            if (trigger_class) {
                const id = trigger_class.replace('tooltip-trigger-', '');
                const $tooltip = $(`.tooltip-${id}`);
                if ($tooltip.length) {
                    $tooltip.toggleClass('active');
                }
            }
        });

        $(document).on('click', function(e) {
            $('.tooltip.active').removeClass('active');
        });

        $(document).on('click', '.tooltip .tooltip-close', function() {
            $('.tooltip.active').removeClass('active');
        });
        
        
    })(jQuery);



    // for the orders form, number the order repeater row sub items
    if (document.querySelector('.acf-field.orders')) {

        const update_row_numbers = () => {
            const rows = document.querySelectorAll('.acf-field.orders > .acf-input > .acf-repeater > .acf-table > tbody > .acf-row');

            rows.forEach((row, index) => {
                const row_num = index + 1;
                const labels = row.querySelectorAll(':scope > td:not(.acf-row-handle) > .acf-field > .acf-label > label');

                labels.forEach(label => {
                    const required = label.querySelector('.required');
                    const base_text = label.childNodes[0].textContent.trim();
                    const clean_text = base_text.replace(/\s+\d+$/, '');
                    label.childNodes[0].textContent = `${clean_text} ${row_num}`;
                });
            });
        };

        // update on page load
        update_row_numbers();

        // Use jQuery for ACF's events
        jQuery('.acf-field.orders').on('change remove append sortstop', function (e) {
            update_row_numbers();
        });
    }

    // ACF validation display workaround for subfields using invalid_field hook
    if (document.querySelector('.acf-field.orders')) {

        if (typeof acf !== 'undefined') {
            acf.addAction('invalid_field', handle_invalid_field);
        }

        function handle_invalid_field() {

            // ensure submit is enabled with invalid fields


            // Get all error messages and look for any with an error-field span
            // These indicate that the message needs to be moved to the appropriate field
            // NOTE: this is not yet set up to work for multiple fields with the same name (e.g. repeaters)
            const error_messages = document.querySelectorAll('.acf-error-message');

            error_messages.forEach(acf_error_message => {

                let remove_error_block = false;
                const error_fields = acf_error_message.querySelectorAll('.error-field');

                error_fields.forEach(error_field => {
                    const error_field_name = error_field.dataset.errorFieldName;

                    if (error_field_name) {
                        const fields = error_field.closest('.af-field');
                        let target;

                        if (fields.dataset.name === error_field_name) {
                            target = fields.querySelector('.acf-input');
                        } else {
                            target = fields.querySelector(`[data-name="${error_field_name}"] .acf-input`);
                        }

                        if (target) {
                            // Clone the parent error field, minus the content
                            const cloned_message = acf_error_message.cloneNode(false);

                            // Clean up the clone to add new data and to prevent it from being reconsidered
                            error_field.classList.remove('error-field');
                            cloned_message.appendChild(error_field);

                            remove_error_block = true; // Mark error block for removal upon completion of loop
                            target.insertAdjacentElement('afterbegin', cloned_message);
                        }
                    }
                });

                if (remove_error_block) {
                    acf_error_message.remove();
                    // Also change the message for the validation summary since we don't have an accurate count any longer
                    // Using MutationObserver instead of arrive.js
                    const observer = new MutationObserver((mutations, obs) => {
                        const dismiss_message = document.querySelector('.acf-error-message.-dismiss p');
                        if (dismiss_message) {
                            dismiss_message.textContent = "Validation failed. One or more fields require attention.";
                            obs.disconnect();
                        }
                    });

                    observer.observe(document.querySelector('.af-form'), {
                        childList: true,
                        subtree: true
                    });
                }
            });
        }

        // Clear custom validation messages when user starts editing related field
        const handle_input_change = (event) => {
            const acf_input = event.target.closest('.acf-input');
            if (acf_input) {
                acf_input.querySelectorAll('.acf-error-message').forEach(msg => msg.remove());
            }
        };

        // Add event listeners for inputs and selects
        document.querySelectorAll('.acf-field input, .acf-field select').forEach(element => {
            element.addEventListener('change', handle_input_change);
        });

        // Clear custom validation messages upon submission
        document.querySelector('.af-submit')?.addEventListener('click', (event) => {
            const form = event.target.closest('form');
            if (form) {
                form.querySelectorAll('.acf-error-message').forEach(msg => msg.remove());
            }
        });

    }

    // populate accounts and validate order quantities based on account properties
    let current_account_type = 'cosmetic';
    if (document.querySelector('.acf-field.orders')) {

        (function($) {

            // Add listeners / functionality to populate account fields based on account selection
            function populate_account_fields(accountId, type_only) {

                return new Promise((resolve) => {
                
                    if (!accountId) {
                        resolve();
                        return;
                    }

                    $.ajax({
                        url: ta_settings.ajax_url,
                        type: 'POST',
                        dataType: 'json',
                        data: {
                            action: 'get_account_details',
                            account_id: accountId,
                            account_details_nonce: ta_settings.nonce
                        },
                        success: function(response) {
                            if (response.success && response.data) {
                                const data = response.data;

                                // store the account type
                                current_account_type = data.account_type.toLowerCase();

                                if(type_only) {
                                    resolve();
                                    return;
                                }
                                
                                // Define field keys
                                const field_keys = {
                                    account_name: 'field_679c60e168d23',
                                    account_number: 'field_679c60fa68d24',
                                    shipping_address_1: 'field_679c6252ee76b',
                                    shipping_address_2: 'field_679c6260ee76c',
                                    shipping_city: 'field_679c6275ee76d',
                                    shipping_state: 'field_679c6284ee76e',
                                    shipping_zip: 'field_679c62f0ee76f',
                                    order_email: 'field_67a4513f01089',
                                    order_email_2: 'field_679c60b268d22',
                                    sales_rep_email: 'field_67dc84b891e2e',
                                };

                                // Try different methods to update fields
                                Object.keys(field_keys).forEach(fieldName => {
                                    const field = acf.getField(field_keys[fieldName]);
                                    if (field) {
                                        field.$input().val(data[fieldName]).trigger('change');
                                    } else {
                                        // Fallback to jQuery selector
                                        $(`[data-key="${field_keys[fieldName]}"] input`).val(data[fieldName]).trigger('change');
                                    }
                                });
                                resolve();
                            } else {
                                resolve();
                            }
                        },
                        error: (xhr, status, error) => {
                            console.error('Error getting acct:', error);
                            reject(error);
                        }
                    });
                });
            }

        
            const account_field = acf.getField('field_67a300461cb5e');
            if (account_field) {
                const initialAccount = account_field.$input().val();
                // do not retrieve data upon load unless there is no data yet
                // because this means that preferences are loaded initially
                const shipping1Field = acf.getField('field_679c6252ee76b');
                let hasData = false;
                if(shipping1Field) {
                    if(shipping1Field.$input().val()) {
                        hasData = true;
                    }
                }

                // if no data, retrieve account details
                // if initialAccount with data, set the current_account_type
                if (initialAccount) {
                    const type_only = hasData;
                    populate_account_fields(initialAccount, type_only);
                }

                // Add change handler
                account_field.$input().on('change', function() {
                    
                    // remove validation notice; it will be replaced if needed
                    $('.surcharge-ack-error').remove();
                    // hide surcharge checkbox; it will be replaced if needed
                    $('.surcharge-acknowledgement').hide();

                    // populate fields and then revalidate quanitites, which can be affected by account type
                    populate_account_fields($(this).val(), false).then(() => {
                        quantity_validator.validate_all_quantities().then(() => {

                            const surcharge_ackd = $('.surcharge-acknowledgement input:checked').length > 0;

                            // absolute max quantity errors
                            if (quantity_validator.validation_errors.length > 0) {
                                // Show errors
                                quantity_validator.show_submission_error();

                            // surcharge triggered, but acknowledgement not acknowledged
                            } else if(quantity_validator.surcharge_warnings.length > 0 && !surcharge_ackd) {
                                quantity_validator.show_surcharge_warnings();
                                const msg = "Please acknowledge the bulk shipment surcharge before continuing."
                                const el = "<div class='surcharge-ack-error'>" + msg + "</div>";
                                $('.surcharge-acknowledgement').prepend(el);

                                // add listener to remove error message when unchecked
                                $('.surcharge-acknowledgement *').on('click', function() {
                                    if($('.surcharge-acknowledgement input:checked').length > 0) {
                                        $('.surcharge-ack-error').remove();
                                    }
                                });
                            }
                        });
                      });
                });
            }
      
        
            // add quantity validation functionality
            // validate SKU max quantities as SKUs are selected
            const quantity_validator = {
                sku_cache: null,
                cache_initialization_promise: null, // Track initialization promise
                validation_errors: [],
                surcharge_warnings: [], // Track surcharge warnings separately

                async init_cache() {
                    // If initialization is already in progress, return that promise
                    if (this.cache_initialization_promise) {
                        return this.cache_initialization_promise;
                    }
                    
                    // If cache is already populated, return a resolved promise
                    if (this.sku_cache) {
                        return Promise.resolve(this.sku_cache);
                    }
                    
                    // Create and store the initialization promise
                    this.cache_initialization_promise = new Promise((resolve, reject) => {
                        $.ajax({
                            url: ta_settings.ajax_url,
                            type: 'POST',
                            dataType: 'json',
                            data: {
                                action: 'get_all_sku_data',
                                ta_nonce: ta_settings.nonce
                            },
                            success: (data) => {
                                if (data.success) {
                                    // Convert array to Map for faster lookups
                                    this.sku_cache = new Map(
                                        data.data.map(item => [item.sku, {
                                            sku_type: item.sku_type,
                                            max_quantity_cosmetic: parseInt(item.max_quantity_cosmetic, 10),
                                            max_quantity_recon: parseInt(item.max_quantity_recon, 10),
                                            max_type: item.max_type
                                        }])
                                    );
                                    resolve(this.sku_cache);
                                } else {
                                    console.error('Error fetching SKU data:', data.message);
                                    reject(new Error(data.message || 'Failed to fetch SKU data'));
                                }
                            },
                            error: (xhr, status, error) => {
                                console.error('Error initializing SKU cache:', error);
                                reject(new Error(error || 'AJAX request failed'));
                            }
                        });
                    });
                    
                    try {
                        return await this.cache_initialization_promise;
                    } catch (error) {
                        // Clear the promise on error so we can try again
                        this.cache_initialization_promise = null;
                        console.error('Cache initialization failed:', error);
                        // Return an empty Map as fallback
                        return new Map();
                    }
                },

                create_modal(title, message, has_close_button = true) {
                    // First, remove any existing quantity warning modals
                    const existingModal = document.querySelector('.quantity-warning-modal');
                    if (existingModal) {
                        existingModal.remove();
                    }
                    
                    // Create new modal
                    const modal = document.createElement('div');
                    modal.className = 'quantity-warning-modal';
                    
                    // Create content with optional close button
                    let content = `
                        <div class="modal-content">
                            <strong>${title}</strong>
                            ${typeof message === 'string' 
                                ? `<p>${message}</p>` 
                                : message.map(msg => `<p>${msg}</p>`).join('')}
                    `;
                    
                    if (has_close_button) {
                        content += `<button type="button" class="close-modal">Okay</button>`;
                    }
                    
                    content += `</div>`;
                    modal.innerHTML = content;
                    
                    document.body.appendChild(modal);
                    
                    // Add event listener for close button
                    if (has_close_button) {
                        const closeButton = modal.querySelector('.close-modal');
                        closeButton.addEventListener('click', () => {
                            modal.style.display = 'none';
                        });
                    }
                    
                    return modal;
                },

                get_applicable_max_quantity(sku_info) {
                    // Use the global current_account_type variable that's set elsewhere
                    // Default to cosmetic if the global variable is not set
                    const account_type = (typeof current_account_type !== 'undefined') ? current_account_type.toLowerCase() : 'cosmetic';
                    
                    // Determine which max quantity to use
                    // Note that any other account types (e.g. "Other") will be treated as cosmetic accounts
                    return account_type === 'reconstruction' 
                        ? sku_info.max_quantity_recon 
                        : sku_info.max_quantity_cosmetic;
                },

                get_type_total_quantity(type, order_items_repeater) {
                    let total = 0;

                    if (!order_items_repeater) return total;

                    // Then only search for rows within this repeater
                    const rows = order_items_repeater.querySelectorAll('.acf-row');

                    rows.forEach(row => {
                        const sku_select = row.querySelector('.acf-field[data-name="sku"] select');
                        const quantity_input = row.querySelector('.acf-field[data-name="quantity"] input[type="number"]');

                        if (sku_select && quantity_input && sku_select.value) {
                            const sku_info = this.sku_cache.get(sku_select.value);
                            if (sku_info && sku_info.sku_type === type) {
                                const quantity = parseInt(quantity_input.value, 10) || 0;
                                total += quantity;
                            }
                        }
                    });

                    return total;
                },

                async validate_quantity(event) {
                    try {
                        // Ensure cache is initialized
                        await this.init_cache();
                        
                        // If we get here, cache is initialized or we have an empty fallback
                        if (!this.sku_cache || this.sku_cache.size === 0) {
                            console.error('SKU cache is empty or initialization failed');
                            return true; // Allow the action to proceed but log an error
                        }
                        
                        const quantity_input = event.target;
                        const row = quantity_input.closest('.acf-row');
                        if (!row) return true;

                        const sku_select = row.querySelector('.acf-field[data-name="sku"] select');
                        if (!sku_select || !sku_select.value) return true;

                        const sku_info = this.sku_cache.get(sku_select.value);
                        if (!sku_info) return true;

                        // Find the order items repeater that contains our quantity input
                        const order_items_repeater = quantity_input.closest('.acf-field[data-name="order_items"]');
                        if (!order_items_repeater) return true;

                        // Get applicable max quantity based on account type
                        const max_quantity = this.get_applicable_max_quantity(sku_info);
                        
                        const total_quantity = this.get_type_total_quantity(sku_info.sku_type, order_items_repeater);

                        if (total_quantity > max_quantity) {
                            if (sku_info.max_type === 'absolute') {
                                this.show_absolute_warning(sku_info.sku_type, max_quantity);
                                return false;
                            } else if (sku_info.max_type === 'surcharge') {
                                this.show_surcharge_warning(sku_info.sku_type, max_quantity);
                                return true; // Still valid, just with a surcharge
                            }
                        }

                        // if no errors or warnings, check all quantities after this event to determine whether surcharge checkbox should be shown
                        quantity_validator.validate_all_quantities().then(() => {
                            if(this.surcharge_warnings.length > 0) {
                                $('.surcharge-acknowledgement').show();
                            } else {
                                $('.surcharge-acknowledgement').hide();
                            }
                        });

                        return true;
                    } catch (error) {
                        console.error('Error during quantity validation:', error);
                        return true; // On error, allow the action but log the error
                    }
                },

                async validate_all_quantities() {
                    try {
                        this.validation_errors = [];
                        this.surcharge_warnings = [];

                        // Ensure cache is initialized
                        await this.init_cache();
                        
                        // If we get here, cache is initialized or we have an empty fallback
                        if (!this.sku_cache || this.sku_cache.size === 0) {
                            console.error('SKU cache is empty or initialization failed');
                            return true; // Allow the action to proceed but log an error
                        }

                        // Get all order items repeaters
                        const repeaters = document.querySelectorAll('.acf-field[data-name="order_items"]');
                        
                        for (let orderIndex = 0; orderIndex < repeaters.length; orderIndex++) {
                            const order_items_repeater = repeaters[orderIndex];
                            const type_quantities = new Map();
                            const type_info = new Map(); // Store max and max_type for each SKU type
                            
                            // Collect quantities for this order
                            order_items_repeater.querySelectorAll('.acf-row').forEach(row => {
                                const sku_select = row.querySelector('.acf-field[data-name="sku"] select');
                                const quantity_input = row.querySelector('.acf-field[data-name="quantity"] input[type="number"]');

                                if (sku_select?.value && quantity_input?.value) {
                                    const sku_info = this.sku_cache?.get(sku_select.value);
                                    if (sku_info) {
                                        const current = type_quantities.get(sku_info.sku_type) || 0;
                                        type_quantities.set(sku_info.sku_type, current + (parseInt(quantity_input.value, 10) || 0));
                                        
                                        // Use the global current_account_type variable
                                        const account_type = (typeof current_account_type !== 'undefined') ? current_account_type : 'cosmetic';
                                        
                                        // Store max and max_type per SKU type
                                        const max_quantity = account_type === 'reconstruction' 
                                            ? sku_info.max_quantity_recon 
                                            : sku_info.max_quantity_cosmetic;
                                        
                                        type_info.set(sku_info.sku_type, {
                                            max: max_quantity,
                                            max_type: sku_info.max_type
                                        });
                                    }
                                }
                            });

                            // Check for violations in this order
                            for (const [type, quantity] of type_quantities) {
                                const info = type_info.get(type);
                                if (quantity > info.max) {
                                    if (info.max_type === 'absolute') {
                                        this.validation_errors.push(`Order ${orderIndex + 1}: SKU type "${type}" has a total quantity of ${quantity}, exceeding the maximum of ${info.max}`);

                                    } else if (info.max_type === 'surcharge') {
                                        
                                        if (type == 'Implants') {
                                            this.surcharge_warnings.push(`Order ${orderIndex + 1}: A $250 bulk shipment surcharge applies to all orders of more than ${info.max} implants.`);
                                        } else if (type == 'Expanders') {
                                            this.surcharge_warnings.push(`Order ${orderIndex + 1}: A $250 bulk shipment surcharge applies to all orders of more than ${info.max} expanders.`);
                                        } else {
                                            this.surcharge_warnings.push(`Order ${orderIndex + 1}: A $250 bulk shipment surcharge applies to all orders of more than ${info.max} ${type} products.`);
                                        }

                                    }
                                }
                            }
                        }

                        return this.validation_errors.length === 0;
                    } catch (error) {
                        console.error('Error during quantities validation:', error);
                        return true; // On error, allow the action but log the error
                    }
                },

                show_absolute_warning(type, max_quantity) {
                    const message = `The total quantity for SKU type "${type}" exceeds the maximum allowed (${max_quantity}). Please reduce the combined quantity of all items of this type.`;
                    const modal = this.create_modal('Quantity Warning', message);
                    modal.style.display = 'block';
                },

                show_surcharge_warning(type, max_quantity) {
                    
                    let message = `A $250 bulk shipment surcharge applies to all orders of more than ${max_quantity} ${type} products.`;

                    if (type == 'Implants') {
                        message = `A $250 bulk shipment surcharge applies to all orders of more than ${max_quantity} implants.`;
                    } else if (type == 'Expanders') {
                        message = `A $250 bulk shipment surcharge applies to all orders of more than ${max_quantity} expanders.`;
                    }
                    
                    const modal = this.create_modal('Surcharge Notice', message);
                    modal.style.display = 'block';
                    $('.surcharge-acknowledgement').show();
                },

                show_surcharge_warnings() {
                    let msg = '';
                    this.surcharge_warnings.forEach(function(warning) {
                        msg += warning + "<br><br>"; 

                    });

                    const modal = this.create_modal('Surcharge Notice', msg);
                    modal.style.display = 'block';
                    $('.surcharge-acknowledgement').show();

                },

                show_submission_error() {
                    // Build message content
                    let messageContent = '';
                    
                    // Add validation errors (that prevent submission)
                    if (this.validation_errors.length > 0) {
                        messageContent += `
                            <div class="error-list">
                                ${this.validation_errors.map(error => `<p>${error}</p>`).join('')}
                            </div>
                            <p>Please correct these issues before submitting.</p>
                        `;
                    }
                    
                    // Add surcharge warnings (that don't prevent submission)
                    if (this.surcharge_warnings.length > 0) {
                        messageContent += `
                            <div class="warning-list">
                                ${this.surcharge_warnings.map(warning => `<p>${warning}</p>`).join('')}
                            </div>
                            <p>These surcharges will be applied to your order if you proceed.</p>
                        `;
                    }
                    
                    // Create appropriate title based on content
                    let title = this.validation_errors.length > 0 ? 'Validation Error' : 'Surcharge Warning';
                    
                    const modal = this.create_modal(title, messageContent);
                    modal.style.display = 'block';
                },

                init() {
                    // Initialize cache when page loads to avoid delays later
                    this.init_cache();

                    // Initialize cache when any SKU select is first interacted with (as backup)
                    document.addEventListener('focus', (event) => {
                        if (event.target.matches('.acf-field[data-name="sku"] select')) {
                            this.init_cache();
                        }
                    }, { once: true });

                    // Validate when quantity changes
                    document.addEventListener('blur', (event) => {
                        if (event.target.matches('.acf-field[data-name="quantity"] input[type="number"]')) {
                            this.validate_quantity(event);
                        }
                    }, true);

                    // Validate when SKU selection changes and quantity exists
                    document.addEventListener('change', (event) => {
                        if (event.target.matches('.acf-field[data-name="sku"] select')) {
                            const row = event.target.closest('.acf-row');
                            const quantity_input = row?.querySelector('.acf-field[data-name="quantity"] input[type="number"]');
                            if (quantity_input && quantity_input.value) {
                                this.validate_quantity({ target: quantity_input });
                            }
                        }
                    }, true);

                    // Validate when account changes (since it affects which max_quantity to use)
                    document.addEventListener('change', (event) => {
                        if (event.target.matches('.acf-field[data-name="account"] select')) {
                            const orderContainer = event.target.closest('.acf-fields');
                            const orderItemsRepeater = orderContainer?.querySelector('.acf-field[data-name="order_items"]');
                            
                            if (orderItemsRepeater) {
                                const quantityInputs = orderItemsRepeater.querySelectorAll('.acf-field[data-name="quantity"] input[type="number"]');
                                quantityInputs.forEach(input => {
                                    if (input.value) {
                                        this.validate_quantity({ target: input });
                                    }
                                });
                            }
                        }
                    }, true);

                    
                    // Add listener to add extra sku-related validation errors
                    function attach_quantity_validation() {
                        $('form.af-form .acf-form-submit button').on('click', function(event) {
                            // Prevent default and validate
                            event.preventDefault();

                            const $submit_btn = $(this);

                            const surcharge_ackd = $('.surcharge-acknowledgement input:checked').length > 0;

                            quantity_validator.validate_all_quantities().then(() => {

                                // absolute max quantity errors
                                if (quantity_validator.validation_errors.length > 0) {
                                    // Show errors
                                    quantity_validator.show_submission_error();

                                // surcharge triggered, but acknowledgement not acknowledged
                                } else if(quantity_validator.surcharge_warnings.length > 0 && !surcharge_ackd) {
                                    $('.surcharge-ack-error').remove();
                                    const msg = "Please acknowledge the bulk shipment surcharge before continuing."
                                    const el = "<div class='surcharge-ack-error'>" + msg + "</div>";
                                    $('.surcharge-acknowledgement').prepend(el);

                                    // add listener to remove error message when unchecked
                                    $('.surcharge-acknowledgement *').on('click', function() {
                                        if($('.surcharge-acknowledgement input:checked').length > 0) {
                                            $('.surcharge-ack-error').remove();
                                        }
                                    });
                                } else {
                                    // Clone the button, replace it, and trigger native action
                                    const $clonedBtn = $submit_btn.clone();
                                    $submit_btn.replaceWith($clonedBtn);
                                    $clonedBtn.trigger('click');
                                    
                                    // Reattach our validation after a delay
                                    // This ensures the validation will run on future submissions
                                    setTimeout(attach_quantity_validation, 500);
                                }
                            }).catch(error => {
                                console.error('Error during validation:', error);
                            });
                        });
                    }

                    // Initial attachment
                    attach_quantity_validation();

                    // Also reattach when ACF validation completes
                    // This ensures we catch scenarios where ACF validation fails
                    // but our quantity validation passes
                    acf.add_action('validation_complete', function(json, $form) {
                        // If validation failed, make sure our handler is attached
                        if (!json.valid) {
                            setTimeout(attach_quantity_validation, 100);
                        }
                    });
                }
            };

            quantity_validator.init();

        })(jQuery);

    }


    // Add type ahead functionality to accounts dropdown
    let last_search_term = '';
    if (document.querySelector('.acf-field.orders')) {

        (function ($) {
            
            // Function to initialize select2 on our field
            function initAccountSearch() {

                // Wait for Advanced Forms to be ready
                const $select = $('.js-ajax-account-search select');
                const $simple_select = $('.af-field-account:not(.js-ajax-account-search) select');

                if ($select.length) {
                    // Destroy existing select2 if it exists
                    if ($select.data('select2')) {
                        $select.select2('destroy');
                    }

                    // Initialize with our configuration
                    $select.select2({
                        ajax: {
                            url: ta_settings.ajax_url,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                last_search_term = params.term;
                                return {
                                    action: 'search_accounts',
                                    term: params.term,
                                    nonce: ta_settings.nonce
                                };
                            },
                            processResults: function (data) {
                                return data;
                            },
                            cache: true
                        },
                        minimumInputLength: 3,
                        placeholder: 'Start typing to search accounts...',
                        width: '100%'
                    });
                } else if($simple_select.length) {
                    // if this is a simple select (all values pre loaded)
                    // just set up a listener to watch for search terms and store them
                    $simple_select.on('select2:open', function() {
                        setTimeout(function() {
                            // Note: the search field gets created when the dropdown opens
                            // Since we know this is the only select2 opening, we can target it directly
                            $('.select2-search__field').off('input keyup.simple-select').on('input keyup.simple-select', function() {
                                const search_term = $(this).val();
                                if (search_term && search_term.length >= 3) {
                                    last_search_term = search_term;
                                }
                            });
                        }, 50);
                    });
                }
            }

            setTimeout(initAccountSearch, 500);

            // Also try to initialize when any Advanced Forms form is loaded
            $(document).on('af/form_success', initAccountSearch);
            $(document).on('af/form_loaded', initAccountSearch);


            // watch for subsequent interaction with the search box and add the existing term if it exists
            $('.af-field-account select').on('select2:open', function() {

                // when the dropdown opens, restore the last search term if it exists
                if (last_search_term) {
                    
                    // small delay to ensure the search input is rendered
                    setTimeout(function() {
                        
                        // find the search input within the select2 dropdown
                        const search_input = $('.select2-search__field');
                        
                        // set the value and trigger the search
                        search_input.val(last_search_term);
                        
                        // trigger the input event to start the search for the AJAX input
                        // and the keyup event to start the search for the simple search input
                        search_input.trigger('input').trigger('keyup');
                        
                        // focus and select all text so user can easily modify it
                        search_input.focus().select();

                    }, 50);
                }
            });

        })(jQuery);

    }

}